import { useMemo } from "react";
import { normalize } from "./commonHooks";


export default function useLeadsFilter(
  leads,
  filterCategory,
  filterProperties,
  filterAgent,
  filterSource,
  sortDate
) {
  return useMemo(() => {
    const normalizedCategory = normalize(filterCategory);
    const normalizedProperty = normalize(filterProperties);
    const normalizedAgent = normalize(filterAgent);
    const normalizedSource = normalize(filterSource);

    return leads
      .filter((lead) => {
        if (
          normalizedCategory !== "all" &&
          normalize(lead.category) !== normalizedCategory
        )
          return false;

        if (
          normalizedProperty !== "all" &&
          normalize(lead.property_name) !== normalizedProperty
        )
          return false;

        if (
          normalizedAgent !== "all" &&
          normalize(lead.agent_name) !== normalizedAgent
        )
          return false;

        if (
          normalizedSource !== "all" &&
          normalize(lead.source) !== normalizedSource
        )
          return false;

        return true;
      })
      .sort((a, b) => {
        const dateA = new Date(a.timeline);
        const dateB = new Date(b.timeline);
        if (sortDate === "Latest") return dateB - dateA;
        return dateA - dateB;
      });
  }, [
    leads,
    filterCategory,
    filterProperties,
    filterAgent,
    filterSource,
    sortDate,
  ]);
}